<!-- <div class="m-subheader" appunwraptag="">
	<div class="d-flex align-items-center">
		<div class="mr-auto">
			<h3 class="m-subheader__title m-subheader__title--separator">
				ToT
			</h3>
			<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
				<li class="m-nav__item m-nav__item--home">
					<a class="m-nav__link m-nav__link--icon">
						<i class="la la-briefcase"></i>
					</a>
				</li>
				<li class="m-nav__separator">
					-
				</li>
				<li class="m-nav__item">
					<span class="m-nav__link-text">
						View Applicant Details
					</span>
				</li>
			</ul>
		</div>
	</div>
</div> -->
<div class="m-content">
    <div class="m-portlet m-portlet--tab">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-text title-style">
                    <button class="btn btn-secondary pull-right" (click)="backClicked()" style="margin-left:10px;">
                        Back
                    </button>
                    <app-file-download class="pull-right" (click)="showResume()" [fileURL]="candidatesData?.resume"
                        buttonText={{buttonText}}></app-file-download>
                    <span *ngIf="actionForRequest" class="notranslate">
                        <button class="btn btn-outline pull-right btn-blue btn-space" data-target="#accept-modal"
                            data-toggle="modal">Approve Request</button>
                        <button class="btn btn-outline pull-right btn-red btn-space" data-target="#reject-modal"
                            data-toggle="modal">Reject Request</button>
                    </span>
                    <span *ngIf="actionForApplicant">
                        <button class="btn btn-outline pull-right btn-blue btn-space"
                            (click)="approveCandidate()">{{ paymentDetails && paymentDetails.modeOfPayment ? 'Approve' : 'Approve Without Payment'}}</button>
                        <button class="btn btn-outline pull-right btn-red btn-space" data-toggle="modal"
                            data-target="#reasonReject_modal" (click)="removeFormValidation()">Reject</button>
                    </span>
                    <label class="col-md-3 col-lg-3 notranslate">View Applicant Details</label>
                </div>
            </div>
        </div>
        <div class="data" style="color: grey; text-align:center">
            <h4>
                {{data}}
            </h4>
        </div>
        
        <div class="m-portlet__body">
            <form class="m-form" *ngIf="candidatesData">
                <!-- personal information -->
                <div>
                    <label class="heading">Personal Information</label>
                    <div class="row">
                        <div class="col-lg-8 col-md-8 col-sm-8">
                            <div class="row">
                                <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                                    Name of the Applicant
                                </label>
                                <span class="col-form-label">:</span>
                                <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                    {{candidatesData.name}}
                                </div>
                                <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                                    Date of Birth
                                </label>
                                <span class="col-form-label">:</span>
                                <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                    {{candidatesData.dob | date: 'dd/MM/yyyy'}}
                                </div>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                                    Gender
                                </label>
                                <span class="col-form-label">:</span>
                                <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                    {{candidatesData.gender}}
                                </div>
                                <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                                    Language Known
                                </label>
                                <span class="col-form-label">:</span>
                                <div class="col-form-label col-lg-3 col-md-3 col-sm-3"
                                    *ngIf="candidatesData?.languagesKnown?.length > 0; else showNABlock">
                                    <span
                                        *ngFor="let language of candidatesData.languagesKnown; let isLast = last">{{language?.name}}{{isLast ? ''
										: ', '}}</span>
                                </div>
                                <ng-template #showNABlock>
                                    <span class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                        N/A
                                    </span>
                                </ng-template>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                                    Religion
                                </label>
                                <span class="col-form-label">:</span>
                                <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                    {{candidatesData?.religion?.name || 'N/A'}}
                                </div>
                                <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                                    Category
                                </label>
                                <span class="col-form-label">:</span>
                                <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                    {{candidatesData?.category?.name || 'N/A'}}
                                </div>
                            </div>
                            <div class="row">
                                <!-- OriginalCategory key is not available in API response -->
                                <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                                    Origination Category
                                </label>
                                <span class="col-form-label">:</span>
                                <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                    {{candidatesData.originationCategory === 'domestic' ? 'Indian National' : candidatesData?.originationCategory === 'international' ? 'NRI/Foreign Residents' : 'N/A'}}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-2">
                            <div class="m-card-profile__pic">
                                <div class="m-card-profile__pic-wrapper pic-alignment">
                                    <img class="image-style"
                                        [src]="profilePhoto ? profilePhoto : '../../assets/images/Dummy_Image_Man.jpg'">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <!-- identity details -->
                <!-- Identity is not available in API response -->
                <div>
                    <label class="heading form-group m-form__group">Identity Details</label>
                    <div class="row">
                        <ng-container
                            *ngIf="candidatesData.identity && candidatesData.identity.name && candidatesData.identity.name !== ''">
                            <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                                Name
                            </label>
                            <span class="col-form-label">:</span>
                            <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                {{candidatesData.identity.name}}
                            </div>
                            <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                                Number
                            </label>
                            <span class="col-form-label">:</span>
                            <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                {{candidatesData.identity.value ? candidatesData.identity.value : 'N/A'}}
                            </div>
                        </ng-container>
                        <ng-container *ngIf="candidatesData.identity && candidatesData.identity.aadhaar &&
						candidatesData.identity.aadhaar !== null && candidatesData.identity.aadhaar.name">
                            <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                                Name
                            </label>
                            <span class="col-form-label">:</span>
                            <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                {{candidatesData.identity.aadhaar.name}}
                            </div>
                            <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                                Number
                            </label>
                            <span class="col-form-label">:</span>
                            <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                {{candidatesData.identity.aadhaar.value ? candidatesData.identity.aadhaar.value : 'N/A'}}
                            </div>
                        </ng-container>
                    </div>
                    <div class="row" *ngIf="candidatesData.originationCategory === 'international'">
                        <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                            Passport Document
                        </label>
                        <span class="col-form-label">:</span>
                        <div class="col-form-label col-lg-6 col-md-6 col-sm-6">
                            <app-file-download [fileURL]="candidatesData?.identity?.supportingDocument"
                                buttonText={{getPassportDocument(candidatesData?.identity?.supportingDocument)}}>
                            </app-file-download>
                        </div>
                    </div>
                </div>
                <hr>
                <!-- contact details -->
                <div>
                    <label class="heading form-group m-form__group">Contact & Address Details</label>
                    <div class="row">
                        <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                            Mobile Number of Applicant
                        </label>
                        <span class="col-form-label">:</span>
                        <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                            {{candidatesData?.phone || 'N/A'}}
                        </div>
                        <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                            <!-- {{ candidatesData.originationCategory === 'domestic' ? 'Pincode' : candidatesData.originationCategory === 'international' ? 'Zipcode' : 'N/A' }} -->
                            Pincode
                        </label>
                        <span class="col-form-label">:</span>
                        <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                            {{candidatesData?.address?.pincode || 'N/A'}}
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                            Email Address of Applicant
                        </label>
                        <span class="col-form-label">:</span>
                        <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                            {{candidatesData?.email || 'N/A'}}
                        </div>
                        <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                            Country
                        </label>
                        <span class="col-form-label">:</span>
                        <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                            {{candidatesData?.address?.country?.name || 'N/A'}}
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                            Applicant Address
                        </label>
                        <span class="col-form-label">:</span>
                        <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                            {{candidatesData?.address?.addressLine1 || 'N/A'}}
                        </div>
                        <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                            Nearby Landmark
                        </label>
                        <span class="col-form-label">:</span>
                        <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                            {{candidatesData?.address?.landmark || 'N/A'}}
                        </div>
                    </div>
                    <div class="row" *ngIf="candidatesData.originationCategory === 'domestic'">
                        <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                            State/Union Territory/Region
                        </label>
                        <span class="col-form-label">:</span>
                        <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                            {{candidatesData?.address?.state?.name || 'N/A'}}
                        </div>
                        <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                            District/City
                        </label>
                        <span class="col-form-label">:</span>
                        <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                            {{candidatesData?.address?.district?.name || 'N/A'}}
                        </div>

                    </div>
                    <div class="row" *ngIf="candidatesData.originationCategory === 'domestic'">
                        <label class="col-form-label col-lg-2 col-md-2 col-sm-2">
                            Tehsil/Mandal
                        </label>
                        <span class="col-form-label">:</span>
                        <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                            {{candidatesData?.address?.mandal?.name || 'N/A'}}
                        </div>
                    </div>
                </div>
                <hr>
                <!-- education details -->
                <div *ngIf="role !== 'Candidate'">
                    <label class="heading form-group m-form__group">Education Details</label>

                    <ng-container *ngFor="let edu of candidatesData.education; let i = index">
                        <br *ngIf="i !== 0">
                        <div class="row">
                            <div class="col-md-3">
                                <label>
                                    {{edu.education.eduQualDesc}} :
                                    <br>
                                </label>
                            </div>
                            <div class="col-md-3">
                                <label>
                                    {{edu.details}}     
                                    <br>
                                </label>
                            </div>
                            <div class="col-md-6" *ngIf="edu.file">
                                <app-file-download class="pull-right" [fileURL]="edu?.supportingDocument"
                                    buttonText={{edu.file}}></app-file-download>
                            </div>
                        </div>
                    </ng-container>

                </div>
                <div *ngIf="role === 'Candidate'">
                    <label class="heading form-group m-form__group">Education Details</label>

                    <ng-container *ngFor="let edu of candidatesData.education; let i = index">
                        <br *ngIf="i !== 0">
                        <div class="row">
                            <div class="col-md-3">
                                <label>
                                    {{edu.education}} :
                                    <br>
                                </label>
                            </div>
                            <div class="col-md-3">
                                <label>
                                    {{edu.educationName}}
                                    <br>
                                </label>
                            </div>
                            <!-- <div class="col-md-6" *ngIf="edu.file">
									<app-file-download class="pull-right" [fileURL]="edu?.supportingDocument" buttonText= {{edu.file}}></app-file-download>
								</div> -->
                        </div>
                    </ng-container>

                </div>
                <hr *ngIf="role !== 'Candidate'">
                <!-- industrial details -->
                <div *ngIf="role !== 'Candidate'">
                    <div class="row">
                        <div class="col-12 col-xl-12 col-sm-12 col-md-12">
                            <h5 class="heading form-group m-form__group">Added Professional Experience Details : <span
                                    style="color:#ef7e22">{{totalWorkingExperienceMonths}}
                                    months Total Professional Experience
                                    Experience</span></h5>
                        </div>
                    </div>
                    <br>
                    <div class="row heading_row">
                        <div class="col-12 col-xl-12 col-sm-12 col-md-12 details-labeldata">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th><b>S No</b></th>
                                        <th><b>Relevant Sector</b></th>
                                        <th><b>Job Title</b></th>
                                        <th><b>Employment Type</b></th>
                                        <th><b>Company</b></th>
                                        <th><b>State</b></th>
                                        <th><b>District</b></th>
                                        <th><b>Address</b></th>
                                        <th><b>Job Description</b></th>
                                        <th><b>Duration</b></th>
                                        <th><b>Proof Document</b></th>
                                    </tr>
                                </thead>
                                <tbody class="notranslate"
                                    *ngIf="candidatesData?.industrialExperience?.length > 0; else industrialElse">
                                    <tr
                                        *ngFor="let industrialExperienceDetail of candidatesData.industrialExperience; let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{industrialExperienceDetail?.sector?.sector}}</td>
                                        <td>{{industrialExperienceDetail?.jobTitle || 'N/A'}}</td>
                                        <td>{{industrialExperienceDetail?.employmentType || 'N/A'}}</td>
                                        <td>{{industrialExperienceDetail?.detailsOfIndustries || 'N/A'}}</td>
                                        <td>{{industrialExperienceDetail?.state?.name || 'N/A'}}</td>
                                        <td>{{industrialExperienceDetail?.district?.name || 'N/A'}}</td>
                                        <td>{{industrialExperienceDetail?.address || 'N/A'}}</td>
                                        <td>{{industrialExperienceDetail?.description || 'N/A'}}</td>
                                        <td>
                                            <span *ngIf="industrialExperienceDetail?.duration?.startDate">
                                                {{industrialExperienceDetail?.duration?.startDate | date: 'dd/MM/yyyy' }}
                                                to
                                            </span>
                                            <span>
                                                {{industrialExperienceDetail?.duration?.endDate ? (industrialExperienceDetail?.duration?.endDate | date: 'dd/MM/yyyy') : industrialExperienceDetail?.duration?.isCurrentlyWorking ? 'Currently Working' : 'N/A' }}
                                            </span>
                                        </td>
                                        <td>
                                            <span style="color:#ef7e22">
                                                <a class="m--font-info" href="javascript:0"
                                                    (click)="downloadPdf(industrialExperienceDetail?.supportingDocument)">{{industrialExperienceDetail?.supportingDocument}}</a>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                                <ng-template #industrialElse>
                                    <ng-container>
                                        <tbody class="text-center" style="width: 116px;display: block;">
                                            <tr class="text-center">No record found</tr>
                                        </tbody>
                                    </ng-container>
                                </ng-template>
                            </table>
                        </div>
                    </div>
                </div>

                <hr *ngIf="role !== 'Candidate'">
                <!-- training exp -->
                <div *ngIf="role !== 'Candidate'">
                    <div class="row">
                        <div class="col-12 col-xl-12 col-sm-12 col-md-12">
                            <h5 class="heading form-group m-form__group">Added {{ experienceFor }} Experience Details : <span
                                    style="color:#ef7e22">
                                    {{totalTrainingExperienceMonths}} months Total
                                    {{ experienceFor }} Experience </span></h5>
                        </div>
                    </div>
                    <br>
                    <div class="row heading_row">
                        <div class="col-12 col-xl-12 col-sm-12 col-md-12 details-labeldata">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th><b>S No</b></th>
                                        <th><b>Relevant Sector</b></th>
                                        <th><b>Job Title</b></th>
                                        <th><b>Employment Type</b></th>
                                        <th><b>Company</b></th>
                                        <th><b>State</b></th>
                                        <th><b>District</b></th>
                                        <th><b>Address</b></th>
                                        <th><b>Job Description</b></th>
                                        <th><b>Duration</b></th>
                                        <th><b>Proof Document</b></th>
                                    </tr>
                                </thead>
                                <tbody class="notranslate"
                                    *ngIf="candidatesData?.trainingExperience?.length > 0; else trainingExpElse">
                                    <tr
                                        *ngFor="let trainingExperienceDetail of candidatesData.trainingExperience; let i = index;">
                                        <td>{{i+1}}</td>
                                        <td>{{trainingExperienceDetail?.sector?.sector}}</td>
                                        <td>{{trainingExperienceDetail?.jobTitle || 'N/A'}}</td>
                                        <td>{{trainingExperienceDetail?.employmentType || 'N/A'}}</td>
                                        <td>{{trainingExperienceDetail?.detailsOfIndustries || 'N/A'}}</td>
                                        <td>{{trainingExperienceDetail?.state?.name || 'N?A'}}</td>
                                        <td>{{trainingExperienceDetail?.district?.name || 'N/A'}}</td>
                                        <td>{{trainingExperienceDetail?.address || 'N/A'}}</td>
                                        <td>{{trainingExperienceDetail?.description || 'N/A'}}</td>
                                        <td>
                                            <span *ngIf="trainingExperienceDetail?.duration?.startDate">
                                                {{trainingExperienceDetail?.duration?.startDate | date: 'dd/MM/yyyy'}}
                                                to
                                            </span>
                                            <span>
                                                {{trainingExperienceDetail?.duration?.endDate ? (trainingExperienceDetail?.duration?.endDate  | date: 'dd/MM/yyyy') : trainingExperienceDetail?.duration?.isCurrentlyWorking ? 'Currently Working' : 'N/A'}}
                                            </span>
                                        </td>
                                        <td>
                                            <span style="color:#ef7e22">
                                                <a class="m--font-info" href="javascript:0"
                                                    (click)="downloadPdf(trainingExperienceDetail?.supportingDocument)">{{trainingExperienceDetail?.supportingDocument}}</a>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                                <ng-template #trainingExpElse>
                                    <ng-container>
                                        <tbody class="m-datatable__body" style="width: 116px;display: block;">
                                            <span class="m-datatable--error">No records found</span>
                                        </tbody>
                                    </ng-container>
                                </ng-template>
                            </table>
                        </div>
                    </div>
                </div>

                <hr *ngIf="role !== 'Candidate'">
                <!-- applicant types -->
                <div>
                    <label class="heading form-group m-form__group">Applicant Type</label>
                    <div class="row">
                        <label class="col-form-label col-lg-3 col-md-3 col-sm-3">
                            {{role}}
                        </label>
                    </div>
                </div>
                <hr>
                <!-- fee payments -->
                <div *ngIf="batchType !== 'pmkvy' && batchType !== 'PMKVY' ">
                    <div *ngIf="isSSC&&batchId">
                        <div class="form-group m-form__group row">
                            <label class="heading col-form-label col-lg-2 col-md-2 col-sm-2">Fee Payment :</label>
                            <div class="heading col-form-label col-lg-2 col-md-2 col-sm-2">
                                <span *ngIf="paymentDetails && paymentDetails.modeOfPayment" style="color : green">
                                    <h5>Payment Received</h5>
                                </span>
                                <span *ngIf="!(paymentDetails && paymentDetails.modeOfPayment)" style="color : red">
                                    <h5>Payment Not Received</h5>
                                </span>
                            </div>
                            <div class="col-form-label col-lg-2 col-md-2 col-sm-2 notranslate">
                                <button class="btn btn-primary" data-target="#view_payment_details"
                                    (click)="getPaymentDetails()" data-toggle="modal">View Payment Details</button>
                            </div>
                        </div>
                        <div class="form-group">
                            Fee applicable for program(inclusive of Training and assessment for One Domain QP and One
                            Platform QP)
                        </div>
                        <label class="heading form-group m-form__group">Fee applicable for Additional QP</label>
                        <div class="row">
                            <label class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                No. of additional manufacuturing QP({{batchFees?.totalTechJR}}) X
                                Rate({{batchFees?.techAssmtFee}}) :
                            </label>
                            <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                {{batchFees?.totalTechAssmtFee}}
                            </div>
                        </div>
                        <div class="row">
                            <label class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                No. of additional Service QP({{batchFees?.totalNonTechJR}}) X
                                Rate({{batchFees?.nonTechAssmtFee}}) :
                            </label>
                            <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                {{batchFees?.totalNonTechAssmtFee}}
                            </div>
                        </div>
                        <div class="form-group m-form__group row">
                            <label class="heading col-form-label col-lg-3 col-md-3 col-sm-3">
                                Total Fee of the program :
                            </label>
                            <div class="col-form-label col-lg-3 col-md-3 col-sm-3">
                                {{batchFees?.totalFees}}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="view_payment_details" *ngIf="batchId" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                    <b>Payment Details</b>
                </h5>
                <button type="button" #closeModal class="close" data-dismiss="modal" aria-label="Close"
                    style="padding-top: 25px;">
                    <!-- <span aria-hidden="true" class="color-info">
						Close
					</span> -->
                </button>
            </div>
            <div class="modal-body">
                <div class="m-section">
                    <div class="m-section__content" *ngIf="paymentDetails">
                        <form class="m-form">
                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">
                                    <b>Batch ID</b>
                                </label>
                                <div class="col-lg-1 col-form-label">:</div>
                                <div class="col-lg-3 col-form-label">
                                    <div class="m-input-icon m-input-icon--right">
                                        {{batchId}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">
                                    <b>Mode of Payment</b>
                                </label>
                                <div class="col-lg-1 col-form-label">:</div>
                                <div class="col-lg-3 col-form-label">
                                    <div class="m-input-icon m-input-icon--right">
                                        {{paymentDetails?.modeOfPayment && paymentDetails.modeOfPayment !== null ? paymentDetails.modeOfPayment : "N/A"}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">
                                    <b>Name of the Bank</b>
                                </label>
                                <div class="col-lg-1 col-form-label">:</div>
                                <div class="col-lg-3 col-form-label">
                                    <div class="m-input-icon m-input-icon--right">
                                        {{paymentDetails?.nameOfBank && paymentDetails.nameOfBank !== '' ? paymentDetails.nameOfBank : 'N/A'}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">
                                    <b>Date of Payment</b>
                                </label>
                                <div class="col-lg-1 col-form-label">:</div>
                                <div class="col-lg-3 col-form-label">
                                    <div class="m-input-icon m-input-icon--right">
                                        <span
                                            *ngIf="paymentDetails.dateOfPayment && paymentDetails.dateOfPayment !== null; else elseBlock">
                                            {{paymentDetails.dateOfPayment | date:'dd/MM/yyyy'}}
                                        </span>
                                        <ng-template #elseBlock>N/A</ng-template>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">
                                    <b>Reference No</b>
                                </label>
                                <div class="col-lg-1 col-form-label">:</div>
                                <div class="col-lg-3 col-form-label">
                                    <div class="m-input-icon m-input-icon--right">
                                        {{paymentDetails.refNo && paymentDetails.refNo !== '' ? paymentDetails.refNo : 'N/A'}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">
                                    <b>Amount</b>
                                </label>
                                <div class="col-lg-1 col-form-label">:</div>
                                <div class="col-lg-3 col-form-label">
                                    <div class="m-input-icon m-input-icon--right">
                                        {{paymentDetails.amount}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-3 col-form-label">
                                    <b>Any Remarks</b>
                                </label>
                                <div class="col-lg-1 col-form-label">:</div>
                                <div class="col-lg-3 col-form-label">
                                    <div class="m-input-icon m-input-icon--right">
                                        {{paymentDetails.remarks && paymentDetails.remarks !== '' ? paymentDetails.remarks : "N/A"}}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="m-section__content" *ngIf="!paymentDetails">
                        No Payment Details!
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary ok-btn" data-dismiss="modal" style="width: 80px;">
                    OK
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="reject-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="exampleModalLabel" style="font-size : 20px!important">
                    Reason for Rejecting Training Request
                </h4>
                <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">
                        &times;
                    </span>
                </button>
            </div>
            <div class="modal-body">
                <form class="m-form align" [formGroup]='actionForm'>
                    <div class="row">
                        <div class="col-md-12">
                            <label><b>Reason:</b></label>
                            <angular2-multiselect formControlName="reason" [data]="rejectedReasonsDropDownData"
                                [settings]="settings">
                            </angular2-multiselect>
                            <app-form-control-messages class="col-12" [control]="actionForm.get('reason')"
                                [name]="'Reason'"></app-form-control-messages>
                        </div>
                    </div>
                    <div class="row" style="margin-top:40px">
                        <div class="col-md-12">
                            <label><b>Comments:</b></label>
                            <div class="form-group">
                                <textarea class="form-control m-input m-input--air" rows="8"
                                    placeholder="If request is rejected, the reason should be provided to Applicant"
                                    formControlName='comment'></textarea>
                                <app-form-control-messages class="col-12" [control]="actionForm.get('comment')"
                                    [name]="'Comments'"></app-form-control-messages>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeModal()">
                    Close
                </button>
                <button type="button" class="btn btn-primary" [disabled]="!actionForm.valid"
                    (click)="submitComments('REJECTED')">
                    Submit
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="accept-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="exampleModalLabel" style="font-size : 20px!important">
                    Reason for Accepting Training Request
                </h4>
                <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">
                        &times;
                    </span>
                </button>
            </div>
            <div class="modal-body">
                <form class="m-form align" [formGroup]='actionForm'>
                    <div class="row" style="margin-top:40px">
                        <div class="col-md-12">
                            <label><b>Comments:</b></label>
                            <div class="form-group">
                                <textarea class="form-control m-input m-input--air" rows="8"
                                    placeholder="If request is approved, the reason should be provided to Applicant"
                                    formControlName='comment'></textarea>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeModal()">
                    Close
                </button>
                <button type="button" class="btn btn-primary"
                    (click)="submitComments('AWAITING_BATCH_ENROLLMENT')">
                    Submit
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="reasonReject_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="exampleModalLabel" style="font-size : 20px!important">
                    Reason for Rejecting Applicant
                </h4>
                <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">
                        &times;
                    </span>
                </button>
            </div>
            <div class="modal-body">
                <form class="m-form align" [formGroup]='actionForm'>
                    <div class="row" style="margin-top:40px">
                        <div class="col-md-12">
                            <div class="form-group">
                                <textarea class="form-control m-input m-input--air" rows="8"
                                    placeholder="If applicant is approved, the reason should be provided to Applicant"
                                    formControlName='comment'></textarea>
                                <app-form-control-messages class="col-12" [control]="actionForm.get('comment')"
                                    [name]="'Comments'"></app-form-control-messages>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeModalReason()">
                    Close
                </button>
                <button type="button" class="btn btn-primary" [disabled]="!actionForm.valid" data-dismiss="modal"
                    (click)="rejectApplicant()">
                    Submit
                </button>
            </div>
        </div>
    </div>
</div>